export enum ProfileState {
  ACTIVE = 'ACTIVE',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}
